import { useEffect, useState, useRef } from "react";
import { api } from "../api.js";
import { getNote, setNote as setLocalNote } from "../lib/notes.js";

// Persoonlijke notitie per town of listing.
// Centraal opgeslagen op de server (gedeeld met je partner), met
// localStorage als snelle cache + offline-fallback.
export function NotesField({ id, placeholder, readOnly = false }) {
  const key = "note_" + String(id).replace(/[^a-z0-9]+/gi, "_");
  const [val, setVal] = useState(() => getNote(id));
  const [saved, setSaved] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    let alive = true;
    setVal(getNote(id));
    api.getSetting(key).then(d => {
      if (alive && d && typeof d.text === "string") {
        setVal(d.text);
        setLocalNote(id, d.text);
      }
    });
    return () => { alive = false; };
  }, [id, key]);

  const handleChange = (e) => {
    const v = e.target.value;
    setVal(v);
    setLocalNote(id, v);          // direct lokaal (instant + offline)
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      api.putSetting(key, { text: v }).then(() => {
        setSaved(true);
        setTimeout(() => setSaved(false), 1500);
      }).catch(() => {});
    }, 600);
  };

  return (
    <section className="notes-field">
      <h4 className="notes-head">📝 Jouw notities</h4>
      <textarea
        className="notes-textarea"
        value={val}
        onChange={handleChange}
        readOnly={readOnly}
        placeholder={placeholder || "Eigen observaties, vragen voor de visit, follow-ups…"}
        rows={4}
      />
      <small className="notes-hint">{saved ? "✓ Opgeslagen" : "Wordt centraal opgeslagen — ook zichtbaar voor je partner."}</small>
    </section>
  );
}
